<template>
    <div>
        <div>
            <strong>开启首充红包：</strong>
            <el-switch
                    style="margin-right: 80px"
                    @change="statusChange"
                    :value="firstCharge.status"
                    :active-value="1"
                    :inactive-value="0"/>
        </div>
        <el-card style="margin: 20px 0">
            <div slot="header">
                <el-date-picker
                        v-model="date"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"/>
                <el-button @click="getTotal" style="margin-left: 15px" type="primary">查询</el-button>
            </div>
            <div style="line-height: 40px">
                <p v-text="`赠送玩家数：${userCount}`"></p>
                <p v-text="`赠送金豆数：${chipSum} 金豆`"></p>
            </div>
        </el-card>

        <el-card class="common-el-card-flex" style="min-height: 600px">
            <div slot="header">
                <strong>参与活动的俱乐部</strong>
                <el-input style="margin-left: 50px" class="common-el-input" placeholder="请输入俱乐部ID/联盟ID"
                          v-model="searchVal"/>
                <el-button type="primary" @click="getList()">搜索</el-button>
                <el-button type="primary" plain style="float: right" @click="showConfig = true">编辑</el-button>
            </div>
            <div class="common-table" style="margin-top: 0;min-height: auto">
                <el-table
                        :data="firstChargeClubList.beanList"
                        v-loading="loading"
                        height="100%">
                    <el-table-column type="index" align="center" label="编号"/>
                    <el-table-column align="center" width="180" label="俱乐部名称" prop="clubName"/>
                    <el-table-column align="center" label="俱乐部ID" prop="clubRandomId"/>
                    <el-table-column align="center" min-width="120" label="俱乐部人数" prop="clubMemberCount"/>
                    <el-table-column align="center" min-width="120" label="已赠送金豆人数" prop="giftMemberCount"/>
                    <el-table-column align="center" min-width="120" label="已赠送金豆数量" prop="giftChipSum"/>
                    <el-table-column align="center" min-width="120" label="赠送数量限额" prop="giftCountLimit"/>
                    <el-table-column align="center" min-width="150" label="所属联盟" prop="tribeName"/>
                    <el-table-column align="center" min-width="120" label="所属联盟ID" prop="tribeRandomId"/>
                </el-table>
            </div>
            <el-pagination
                    class="common-el-pagination"
                    background
                    layout="prev,pager,next,jumper"
                    :page-size="20"
                    :page-count="5"
                    :total="firstChargeClubList.total"
                    :current-page="currentPage"/>
        </el-card>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>短信验证</h3>
                <table class="common-popup-table">
                    <tr>
                        <td>
                            <el-input placeholder="请输入验证码" v-model="code"></el-input>
                        </td>
                        <td>
                            <btnCountdown text="发送短信" @my-click="sendCodeFunc"/>
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="closeMsgCode">取消</el-button>
                    <el-button
                            size="small"
                            @click="submitMsgCode"
                            type="primary">确定
                    </el-button>
                </footer>
            </div>
        </div>

        <div v-show="showConfig" class="common-popup-bg">
            <div class="common-popup">
                <i class="common-popup-close el-icon-close" @click="showConfig = false;getList(currentPage)"></i>
                <comp-club-config/>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import btnCountdown from 'components/btnCountdown'
    import compClubConfig from './compClubConfig'

    export default {
        components: {
            btnCountdown,
            compClubConfig
        },
        data() {
            return {
                loading: false,
                show: false,
                showConfig: false,
                statusChangeValue: null,//将要改变的值
                code: '',
                date: null,
                userCount: 0,
                chipSum: 0,
                searchVal: '',
                currentPage: 1
            }
        },
        computed: {
            ...mapState('activity', ['firstCharge', 'firstChargeClubList'])
        },
        created() {
            this.getDetail();
            this.getAllUnionList();
            this.getList();
        },
        methods: {
            ...mapActions('other', ['sendCodeToMyPhone']),
            ...mapActions('union', ['getAllUnionList']),
            ...mapActions('activity', ['getFirstCharge', 'updateFirstChargeStatus', 'getFirstChargeTotal', 'getFirstChargeClubList']),
            getDetail() {
                this.getFirstCharge().then(() => {
                })
            },
            getTotal() {
                if (!this.date) {
                    this.$message.error('请选择日期');
                    return
                }
                this.getFirstChargeTotal({
                    startDate: this.date[0],
                    endDate: this.date[1]
                }).then(res => {
                    this.userCount = res.data.userCount;
                    this.chipSum = res.data.chipSum;
                })
            },
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getFirstChargeClubList({
                    clubOrTribeRandomId: this.searchVal,
                    page
                }).then(() => {
                    this.loading = false
                })
            },
            updateCountLimit({value, cb}) {
                if (value < 0) {
                    this.$message.error('限额不能小于0');
                    return
                }
                this.updateRedPackLimit({
                    id: this.redPack.id,
                    accountLimit: value
                }).then(() => {
                    cb();
                    this.$message.success('修改成功');
                    this.getDetail()
                })
            },
            statusChange(value) {
                this.statusChangeValue = value;
                this.show = true;
            },
            // 发送短信
            sendCodeFunc(e) {
                //关闭19 启用18
                let type = this.statusChangeValue ? 18 : 19;
                this.sendCodeToMyPhone({err: e.err, type})
            },
            submitMsgCode() {
                if (!this.code) {
                    this.$message.error('请输入验证码');
                    return
                }
                this.updateFirstChargeStatus({
                    smsCode: this.code,
                    status: this.statusChangeValue
                }).then(() => {
                    this.$message.success('修改成功');
                    this.closeMsgCode();
                    this.getDetail();
                })
            },
            closeMsgCode() {
                this.code = '';
                this.show = false;
            }
        }
    }
</script>